import { HelpCenter, PublicLocale } from "../../../types";
import { HelpCenterActionTypes, SET_INITIAL_STATE, SET_LOCALE } from "./types";

export function setInitialState(helpCenter: HelpCenter): HelpCenterActionTypes {
  return {
    type: SET_INITIAL_STATE,
    helpCenter: helpCenter,
  };
}

export function setLocale(locale: PublicLocale): HelpCenterActionTypes {
  return {
    type: SET_LOCALE,
    locale: locale,
  };
}
